import React, {Component} from 'react';
import {bindActionCreators} from "redux";
import {updateCategories, updateMainPage, updateNavigationParam, updateUser} from "../../redux/systemSlice";
import {connect} from "react-redux";

import './partners.css';
import Utils from "../../utils";

import PartnersLogo from "../../images/partners-logo.png";
import {ReactComponent as BusinessLogo} from "../../images/business-logo.svg";
import {ReactComponent as BusinessPhone} from "../../images/business-phone.svg";
import {ReactComponent as PartnersTelegram} from "../../images/partners-telegram.svg";
import {ReactComponent as PartnersPercent} from "../../images/partners-percent.svg";
import {ReactComponent as BusinessBeer} from "../../images/business-beer.svg";
import {ReactComponent as BusinessPicture} from "../../images/business-picture.svg";
import {ReactComponent as BusinessPeople} from "../../images/business-people.svg";
import {ReactComponent as BusinessSale} from "../../images/business-sale.svg";
import {ReactComponent as BusinessArrow} from "../../images/business-arrow.svg";
import {ReactComponent as PartnersOwnContent} from "../../images/partners-own-content.svg";
import {ReactComponent as PartnersScreens} from "../../images/partners-screens.svg";
import {ReactComponent as PartnersMenu} from "../../images/partners-menu.svg";
import {ReactComponent as PartnersEditor} from "../../images/partners-editor.svg";
import {ReactComponent as PartnersDisabled} from "../../images/partners-disabled.svg";
import {ReactComponent as PartnersOpenCloser} from "../../images/partners-opencloser.svg";
import {ReactComponent as PartnersOpenCloserClose} from "../../images/partners-opencloser-close.svg";
import {ReactComponent as PartnersLogin} from "../../images/partners-login.svg";
import {Link} from "react-router-dom";
import ModalComponent from "../../app/components/modalComponent/modalComponent";
import API from "../../app/api";


const tags = [
    {
        text: 'Интерактивные меню-борды',
        deg: (Math.random() * 10) - 5
    },
    {
        text: 'Ремонт',
        deg: (Math.random() * 10) - 5
    },
    {
        icon: <BusinessBeer/>,
        deg: (Math.random() * 10) - 5
    },
    {
        text: 'Наружная реклама',
        deg: (Math.random() * 10) - 5
    },
    {
        text: 'Дизайн-проект',
        deg: (Math.random() * 10) - 5
    },
    {
        text: 'Холодильные камеры',
        deg: (Math.random() * 10) - 5
    },
    {
        icon: <BusinessPicture/>,
        deg: (Math.random() * 10) - 5
    },
    {
        text: 'Сплит-системы',
        deg: (Math.random() * 10) - 5
    },
    {
        text: 'Барные стойки, мебель',
        deg: (Math.random() * 10) - 5
    },
    {
        text: 'Система ЕГАИС',
        deg: (Math.random() * 10) - 5,
    },
    {
        text: 'Настройка кассы',
        deg: (Math.random() * 10) - 5
    },
    {
        icon: <BusinessPeople/>,
        deg: (Math.random() * 10) - 5
    },
    {
        text: 'Сдача алкодекларации',
        deg: (Math.random() * 10) - 5
    },
    {
        text: 'Линия розлива, подключение кранов',
        deg: (Math.random() * 10) - 5
    },
    {
        icon: <BusinessSale/>,
        deg: (Math.random() * 10) - 5
    },
]


const questions = [
    {
        title: 'Зачем мне меню-борды? Я пишу всё на бумажных ценниках или доске',
        description: 'Меню-борды упрощают обновление меню, делают информацию более заметной и привлекательной для гостей, что увеличит продажи и улучшит впечатление от посещения вашей пивной.'
    },
    {
        title: 'Что нужно для подключения?',
        description: 'Смарт-телевизор или приставка на базе Android и подключение к интернету на точке.'
    },
    {
        title: 'Вы предоставляете телевизоры и приставки?',
        description: 'Нет, телевизоры или приставки вы приобретаете самостоятельно, но мы можем помочь определиться с моделью и версией ПО для устройств.'
    },
    {
        title: 'Можно получить доступ до оплаты?',
        description: 'Да, мы предоставляем бесплатный демонстрационный доступ'
    },
    {
        title: 'Что будет при отключении интернета на точке?',
        description: 'Ничего, меню продолжит отображаться, но не будет обновляться до восстановления подключения.'
    },
]


class PartnersPage extends Component {
    constructor(props) {
        super(props);

        this.state = {
            activeTab: 0,
            deg: 0,

            imagesScroll: -window.innerWidth / 10,

            accordionTabActive: 0,

            isModalOpen: false,

            name: '',
            phone: '',

            isSuccess: false,

            isOpenMobileModal: false
        }

        this.setModalStatus = (status) => this.setState({isModalOpen: status})

        this.setAccordionTab = (index) => {
            if (this.state.accordionTabActive === index) {
                this.setState({accordionTabActive: null})

                questions.forEach((question, thisIndex) => {
                    const container = document.getElementById(`question-${thisIndex}`);
                    container.style.height = '0px';
                })
            } else {
                this.setState({accordionTabActive: index})

                questions.forEach((question, thisIndex) => {
                    if (thisIndex === index) {
                        const container = document.getElementById(`question-${thisIndex}`);
                        container.style.height = container.scrollHeight * 1.6 + (16 * 2) + 'px';
                    } else {
                        const container = document.getElementById(`question-${thisIndex}`);
                        container.style.height = '0px';
                    }
                })
            }
        }

        this.scrollToElement = (elementId) => {
            const element = document.getElementById(elementId);
            const offset = 140;

            const elementPosition = element.getBoundingClientRect().top;

            const offsetPosition = window.pageYOffset + elementPosition - offset;

            window.scrollTo({
                top: offsetPosition,
                behavior: 'smooth'
            });
        }

        this.scrollToSalary = () => {
            this.scrollToElement('salary');
        }

        this.sendBusinessRequest = () => {
            if (this.state.name.length && this.state.phone.length) {
                API.sendBusinessLandingRequest(this.state.name, this.state.phone)
                    .then(data => {
                        this.setState({
                            name: '',
                            phone: '',
                            isSuccess: true
                        })
                        setTimeout(() => {
                            this.setState({
                                isModalOpen: false,
                                isSuccess: false
                            })
                        }, 3000)
                    })
            }
        }

        this.handleScroll = this.handleScroll.bind(this);
    }

    handleScroll() {
        const startElement = document.querySelector('.scroll-start');
        const endElement = document.querySelector('.scroll-end');
        if (!startElement || !endElement) return;

        const start = startElement.offsetTop;
        const end = endElement.offsetTop;
        const scrollPos = window.scrollY;

        const progress = Math.min(Math.max((scrollPos - start) / (end - start), 0), 1);
        const maxScroll = 1000;

        this.setState({imagesScroll: (-window.innerWidth / 10) + maxScroll * progress})
    }

    componentDidMount() {
        this.props.updateNavigationParam({
            page: 'business',
        })

        Utils.setPageTitle(`Меню-борды для вашего заведения | ПабХаб`)

        setInterval(() => {
            this.setState({
                activeTab: this.state.activeTab + 1 === tags.length ? 0 : this.state.activeTab + 1,
                deg: (Math.random() * 10) - 5
            })
        }, 800)

        window.addEventListener('scroll', this.handleScroll);

        this.scrollToElement('partners-page')
    }

    render() {
        return (
            <div id='partners-page' className='partners-page-container'>
                <div className='header'>
                    <div className='icon-button'
                         onClick={() => this.setState({isOpenMobileModal: !this.state.isOpenMobileModal})}>
                        <PartnersOpenCloser/>
                    </div>
                    <Link className='logo-container' to='/'>
                        <img src={PartnersLogo} alt='logo'/>
                        <div className='text'>ПабХаб</div>
                    </Link>
                    <div className='tabs'>
                        <div className='tab' onClick={() => this.scrollToElement('block-2')}>Кому подойдёт?</div>
                        <div className='tab' onClick={() => this.scrollToElement('block-6')}>Тарифы</div>
                        <div className='tab' onClick={() => this.scrollToElement('block-10')}>Ответы</div>
                    </div>
                    <div className='buttons'>
                        <a className='button gray' href='tel:+79505071316' target='_blank'>
                            <div className='phone'>
                                <BusinessPhone/>
                                8 950 507 13 16
                            </div>
                            <div className='span'>Пишите, звоните</div>
                        </a>
                        <a className='button gray hidden' href='https://t.me/pubhubsu' target='_blank'>
                            <div className='phone'>
                                <PartnersTelegram/>
                                @pubhubsu
                            </div>
                            <div className='span'>telegram</div>
                        </a>
                        <Link className='button primary' to='/register/partners/'>
                            Попробовать бесплатно
                        </Link>
                        <Link className='button secondary' to='/login/partners/'>
                            Войти
                        </Link>
                    </div>
                    <Link className='icon-button' to='/login/partners/'>
                        <PartnersLogin/>
                    </Link>
                </div>
                <div className='content'>
                    <div className='entry'>
                        <div className='block-1'>
                            <div className='header'>
                                <div className='title'>Меню-борды для вашего заведения</div>
                                <div className='description'>
                                    ПабХаб — система управления контентом
                                    <br/><br/>
                                    Показывайте меню, рекламу, видео и всё, что
                                    угодно на своих экранах
                                </div>
                            </div>
                            <div className='banner'>
                                <video
                                    src='https://s3.regru.cloud/media.pubhub/images/portal/other/landing.mp4'
                                    loop
                                    muted
                                    autoPlay
                                    playsInline
                                    controls={false}
                                ></video>
                            </div>
                            <div className='tags-root-container'>
                                <div className='title'>Увеличиваем</div>
                                <div className='tags'>
                                    <div className='tag green'>
                                        продажи
                                        <span>💰</span>
                                    </div>
                                    <div className='tag orange'>
                                        поток клиентов
                                        <span>🏃‍♂️</span>
                                    </div>
                                    <div className='tag purple'>
                                        средний чек
                                        <span>📊</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div id='block-2' className='block-2 scroll-start'>
                            <div className='title'>
                                Кому подойдёт?
                            </div>
                            <div className='content'>
                                <div className='column left'>
                                    <div className='card'>
                                        <div className='header'>
                                            <div className='icon'>🍻</div>
                                            <div className='entry'>
                                                <div className='title'>Пивному магазину</div>
                                                <div className='description'>или бару</div>
                                            </div>
                                        </div>
                                        <div className='text'>
                                            Заполните меню в личном кабинете и расположите на экранах так, как считаете
                                            нужным. Меню привязано к пивному порталу. Клиенты оставят отзывы на портале,
                                            который показывает местоположение точки, рейтинг всех позиций и выводится в
                                            поиске яндекса.
                                        </div>
                                        <div className='button' onClick={() => this.scrollToElement('block-6')}>
                                            Тариф для пивных магазинов
                                        </div>
                                    </div>
                                    <div className='card-stock'>
                                        <div className='icon'>
                                            <PartnersPercent/>
                                        </div>
                                        <div className='entry'>
                                            <div className='title'>Выгодные условия для крупных сетей</div>
                                            <div className='description'>и скидки при оплате от 3 месяцев</div>
                                        </div>
                                    </div>
                                </div>
                                <div className='column right'>
                                    <div className='card'>
                                        <div className='header'>
                                            <div className='icon'>🌯</div>
                                            <div className='entry'>
                                                <div className='title'>Кофейне, закусочной,</div>
                                                <div className='description'>спортзалу, фудкорту..</div>
                                            </div>
                                        </div>
                                        <div className='text'>
                                            Можно выводить любое изображение, баннер или меню через единый кабинет на
                                            все точки. Включайте ротацию контента, привлекайте клиентов новой ежедневной
                                            акцией
                                        </div>
                                        <div className='button' onClick={() => this.scrollToElement('block-6')}>
                                            Забыть про флешки
                                        </div>
                                    </div>
                                    <div className='card'>
                                        <div className='header'>
                                            <div className='icon'>🖥️</div>
                                            <div className='entry'>
                                                <div className='title'>Любому, у кого есть экраны</div>
                                                <div className='description'>или желание их поставить</div>
                                            </div>
                                        </div>
                                        <div className='text'>
                                            Мы не откажемся сделать что-нибудь специально под ваши нужды и требования, —
                                            умеем всё, что можно представить
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className='block-3'>
                            <div className='title'>ПабХаб в действии</div>
                            <div className='images'>
                                <div className='entry'>
                                    <div className='elements'
                                         style={{transform: `translateX(${-this.state.imagesScroll}px)`}}>
                                        <img src='https://s3.regru.cloud/media.pubhub/images/portal/other/partners-1.png' alt='1'/>
                                        <img src='https://s3.regru.cloud/media.pubhub/images/portal/other/partners-2.png' alt='2'/>
                                        <img src='https://s3.regru.cloud/media.pubhub/images/portal/other/partners-3.png' alt='3'/>
                                        <img src='https://s3.regru.cloud/media.pubhub/images/portal/other/partners-4.png' alt='4'/>
                                        <img src='https://s3.regru.cloud/media.pubhub/images/portal/other/partners-5.png' alt='5'/>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className='block-4 scroll-end'>
                            <div className='title'>Почему стоит выбрать нас?</div>
                            <div className='rows'>
                                <div className='row'>
                                    <div className='card'>
                                        <div className='top'>
                                            <span>🎯</span>
                                            Показывайте баннеры
                                        </div>
                                        <div className='bottom'>
                                            Покажите клиенту акции в своём магазине — картинкой, видео, или и тем и
                                            другим сразу
                                        </div>
                                    </div>
                                    <div className='card'>
                                        <div className='top'>
                                            <span>📱</span>
                                            QR-меню для клиентов
                                        </div>
                                        <div className='bottom'>
                                            У вас будет собственная страница на пивном портале, где будет отображено
                                            ваше меню, адрес и геопозиция на картах яндекса
                                        </div>
                                    </div>
                                    <div className='card'>
                                        <div className='top'>
                                            <span>💸</span>
                                            Меняйте цены в любой момент
                                        </div>
                                        <div className='bottom'>
                                            Больше не нужно развозить по точкам флешки или другие носители информации —
                                            всё работает через интернет
                                        </div>
                                    </div>
                                </div>
                                <div className='row'>
                                    <div className='card'>
                                        <div className='top'>
                                            <span>✏️</span>
                                            Дизайн под ключ
                                        </div>
                                        <div className='bottom'>
                                            Создадим уникальный визуал, который отразит дух вашего заведения. Мы
                                            предлагаем стильные шаблоны, которые легко адаптируются под ваш бренд
                                        </div>
                                    </div>
                                    <div className='card'>
                                        <div className='top'>
                                            <span>⏱</span>
                                            Экономьте время
                                        </div>
                                        <div className='bottom'>
                                            Каждый час, потраченный на рутину, — это упущенная возможность заработать.
                                            Забудьте о перепечатке ценников, стикеров или бумажных меню
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className='block-5'>
                            <div className='title'>Выгодно, просто и удобно</div>
                            <div className='block'>
                                <div className='left'>
                                    <div className='content'>
                                        <div className='price'>
                                            от 1 900 ₽ / месяц
                                        </div>
                                        <div className='text'>
                                            Стоимость подключения одной точки — меньше, чем приносит одна проданная
                                            кега, а пользы несоизмеримо больше. Цены начинаются от 1 900 ₽
                                        </div>
                                    </div>
                                    <Link className='button' to='/register/partners/'>
                                        Попробовать бесплатно
                                    </Link>
                                </div>
                                <div className='right'>
                                    <div className='card'>
                                        <div className='sale'>— 5%</div>
                                        <div className='content'>
                                            <span>💡</span>
                                            при оплате от 3 месяцев
                                        </div>
                                        <div className='rectangle'>
                                            <svg width="183" height="268" viewBox="0 0 183 268" fill="none"
                                                 xmlns="http://www.w3.org/2000/svg">
                                                <g filter="url(#filter0_f_4604_143451)">
                                                    <rect width="510.35" height="453.17" rx="226.585"
                                                          transform="matrix(-0.928836 -0.37049 0.387563 -0.921843 206.738 469.326)"
                                                          fill="#5773FF"/>
                                                </g>
                                                <defs>
                                                    <filter id="filter0_f_4604_143451" x="-413.745" y="-286.478"
                                                            width="942.567" height="904.776"
                                                            filterUnits="userSpaceOnUse"
                                                            color-interpolation-filters="sRGB">
                                                        <feFlood flood-opacity="0" result="BackgroundImageFix"/>
                                                        <feBlend mode="normal" in="SourceGraphic"
                                                                 in2="BackgroundImageFix" result="shape"/>
                                                        <feGaussianBlur stdDeviation="108.311"
                                                                        result="effect1_foregroundBlur_4604_143451"/>
                                                    </filter>
                                                </defs>
                                            </svg>
                                        </div>
                                    </div>
                                    <div className='card'>
                                        <div className='sale'>— 10%</div>
                                        <div className='content'>
                                            <span>🔥</span>
                                            при оплате от 6 месяцев
                                        </div>
                                        <div className='rectangle'>
                                            <svg width="184" height="268" viewBox="0 0 184 268" fill="none"
                                                 xmlns="http://www.w3.org/2000/svg">
                                                <g filter="url(#filter0_f_4604_143455)">
                                                    <path
                                                        d="M295.552 260.451C247.053 375.809 113.51 431.742 -2.72393 385.379L-55.8355 364.194C-172.069 317.831 -226.979 186.73 -178.48 71.3709C-129.98 -43.988 3.56264 -99.9202 119.797 -53.5573L172.908 -32.3724C289.142 13.9905 344.052 145.092 295.552 260.451Z"
                                                        fill="#B341FF"/>
                                                </g>
                                                <defs>
                                                    <filter id="filter0_f_4604_143455" x="-412.747" y="-286.478"
                                                            width="942.567" height="904.776"
                                                            filterUnits="userSpaceOnUse"
                                                            color-interpolation-filters="sRGB">
                                                        <feFlood flood-opacity="0" result="BackgroundImageFix"/>
                                                        <feBlend mode="normal" in="SourceGraphic"
                                                                 in2="BackgroundImageFix" result="shape"/>
                                                        <feGaussianBlur stdDeviation="108.311"
                                                                        result="effect1_foregroundBlur_4604_143455"/>
                                                    </filter>
                                                </defs>
                                            </svg>

                                        </div>
                                    </div>
                                    <div className='card'>
                                        <div className='sale'>— 15%</div>
                                        <div className='content'>
                                            <span>😎</span>
                                            при оплате от 12 месяцев
                                        </div>
                                        <div className='rectangle'>
                                            <svg width="183" height="268" viewBox="0 0 183 268" fill="none"
                                                 xmlns="http://www.w3.org/2000/svg">
                                                <g filter="url(#filter0_f_4604_143459)">
                                                    <path
                                                        d="M294.556 260.451C246.057 375.809 112.514 431.742 -3.72003 385.379L-56.8316 364.194C-173.066 317.831 -227.975 186.73 -179.476 71.3709C-130.976 -43.988 2.56655 -99.9202 118.801 -53.5573L171.912 -32.3724C288.146 13.9905 343.056 145.092 294.556 260.451Z"
                                                        fill="#FF5053"/>
                                                </g>
                                                <defs>
                                                    <filter id="filter0_f_4604_143459" x="-413.743" y="-286.478"
                                                            width="942.567" height="904.776"
                                                            filterUnits="userSpaceOnUse"
                                                            color-interpolation-filters="sRGB">
                                                        <feFlood flood-opacity="0" result="BackgroundImageFix"/>
                                                        <feBlend mode="normal" in="SourceGraphic"
                                                                 in2="BackgroundImageFix" result="shape"/>
                                                        <feGaussianBlur stdDeviation="108.311"
                                                                        result="effect1_foregroundBlur_4604_143459"/>
                                                    </filter>
                                                </defs>
                                            </svg>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div id='block-6' className='block-6'>
                            <div className='title'>Тарифы</div>
                            <div className='columns'>
                                <div className='column'>
                                    <div className='card'>
                                        <div className='content'>
                                            <div className='header'>
                                                <div className='title'>
                                                    Пивной
                                                    <span>лучший выбор</span>
                                                </div>
                                                <div className='description'>
                                                    Всё доступно, но есть ограничения на экраны
                                                </div>
                                            </div>
                                            <div className='attrs'>
                                                <div className='row'>
                                                    <div className='attr'>
                                                        <PartnersOwnContent/>
                                                        Свой контент
                                                    </div>
                                                    <div className='attr'>
                                                        <PartnersScreens/>
                                                        До 3 экранов
                                                    </div>
                                                </div>
                                                <div className='row'>
                                                    <div className='attr'>
                                                        <PartnersMenu/>
                                                        Пивное, QR-меню
                                                    </div>
                                                    <div className='attr'>
                                                        <PartnersEditor/>
                                                        Конструктор позиций
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className='price-container'>
                                            <div className='price'>3 900 ₽</div>
                                            <div className='label'>в месяц</div>
                                        </div>
                                    </div>
                                    <div className='card'>
                                        <div className='content'>
                                            <div className='header'>
                                                <div className='title'>
                                                    Пивной Плюс
                                                </div>
                                                <div className='description'>
                                                    Полный доступ к сервису
                                                </div>
                                            </div>
                                            <div className='attrs'>
                                                <div className='row'>
                                                    <div className='attr'>
                                                        <PartnersOwnContent/>
                                                        Свой контент
                                                    </div>
                                                    <div className='attr'>
                                                        <PartnersScreens/>
                                                        До 6 экранов
                                                    </div>
                                                </div>
                                                <div className='row'>
                                                    <div className='attr'>
                                                        <PartnersMenu/>
                                                        Пивное, QR-меню
                                                    </div>
                                                    <div className='attr'>
                                                        <PartnersEditor/>
                                                        Конструктор позиций
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className='price-container'>
                                            <div className='price'>4 600 ₽</div>
                                            <div className='label'>в месяц</div>
                                        </div>
                                    </div>
                                </div>
                                <div className='column'>
                                    <div className='card white'>
                                        <div className='content'>
                                            <div className='header'>
                                                <div className='title'>
                                                    Базовый
                                                </div>
                                                <div className='description'>
                                                    Подходит для кофеен, закусочных и др.
                                                </div>
                                            </div>
                                            <div className='attrs'>
                                                <div className='row'>
                                                    <div className='attr'>
                                                        <PartnersOwnContent/>
                                                        Свой контент
                                                    </div>
                                                    <div className='attr'>
                                                        <PartnersScreens/>
                                                        До 3 экранов
                                                    </div>
                                                </div>
                                                <div className='row'>
                                                    <div className='attr'>
                                                        <PartnersDisabled/>
                                                        Пивное меню
                                                    </div>
                                                    <div className='attr'>
                                                        <PartnersDisabled/>
                                                        Конструктор позиций
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className='price-container'>
                                            <div className='price'>1 900 ₽</div>
                                            <div className='label'>в месяц</div>
                                        </div>
                                    </div>
                                    <div className='card white'>
                                        <div className='content'>
                                            <div className='header'>
                                                <div className='title'>
                                                    Базовый Плюс
                                                </div>
                                                <div className='description'>
                                                    Подходит для кофеен, закусочных, без ограничений
                                                </div>
                                            </div>
                                            <div className='attrs'>
                                                <div className='row'>
                                                    <div className='attr'>
                                                        <PartnersOwnContent/>
                                                        Свой контент
                                                    </div>
                                                    <div className='attr'>
                                                        <PartnersScreens/>
                                                        До 6 экранов
                                                    </div>
                                                </div>
                                                <div className='row'>
                                                    <div className='attr'>
                                                        <PartnersDisabled/>
                                                        Пивное меню
                                                    </div>
                                                    <div className='attr'>
                                                        <PartnersDisabled/>
                                                        Конструктор позиций
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className='price-container'>
                                            <div className='price'>3 600 ₽</div>
                                            <div className='label'>в месяц</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className='block-7'>
                            <div className='title'>Отзывы</div>
                            <div className='items'>
                                <div className='card'>
                                    <div className='header'>
                                        <div className='avatar'>
                                            <img
                                                src='http://s3.regru.cloud/media.pubhub/images/portal/other/portal-review-avatar-1.png'
                                                alt=''/>
                                        </div>
                                        <div className='content'>
                                            <div className='title'>Иван</div>
                                            <div className='description'>Владелец сети «Пивная корова»</div>
                                        </div>
                                    </div>
                                    <div className='text'>
                                        Благодаря ПабХабу мы наконец-то навели порядок в управлении ассортиментом.
                                        Раньше обновление меню занимало кучу времени — сделать макет, развезти флешки по
                                        точкам. А теперь всё делается в пару кликов: привязал пиво к кранам, добавил
                                        фото, и готово.<br/><br/>

                                        С цифровыми бордами клиенты стали чаще брать дорогие сорта. Показываем
                                        премиум-пиво с описанием на экранах — и апселлинг сработал, средний чек вырос на
                                        15%
                                    </div>
                                </div>
                                <div className='card'>
                                    <div className='header'>
                                        <div className='avatar'>
                                            <img
                                                src='http://s3.regru.cloud/media.pubhub/images/portal/other/portal-review-avatar-2.png'
                                                alt=''/>
                                        </div>
                                        <div className='content'>
                                            <div className='title'>Оганес</div>
                                            <div className='description'>Владелец сети «Traffic»</div>
                                        </div>
                                    </div>
                                    <div className='text'>
                                        Мы продаём на каждой своей точке не только пиво, а ещё и кофе. Удобно
                                        распределять экраны из одного кабинета и выводит акции на каждый день недели.
                                        <br/><br/>

                                        Пабхаб здорово упростил нам работу. Менеджеры быстро привыкли к интерфейсу и
                                        обновляют меню через платформу, всё сразу появляется на экранах.
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className='block-8'>
                            <div className='title'>Возможности системы</div>
                            <div className='cards'>
                                <div className='card'>
                                    <span>📺</span>
                                    <div className='title'>Пивное меню</div>
                                    <div className='description'>
                                        Идеально адаптированы под задачи баров и пивнух. Каждая деталь продумана до
                                        мелочей, чтобы увеличивать продажи и радовать ваших гостей
                                    </div>
                                </div>
                                <div className='card'>
                                    <span>🎛️</span>
                                    <div className='title'>Конструктор позиций</div>
                                    <div className='description'>
                                        Легко создавайте и редактируйте меню — добавляйте товары, настраивайте
                                        категории, загружайте фото и цены в пару кликов
                                    </div>
                                </div>
                                <div className='card'>
                                    <span>🖼️</span>
                                    <div className='title'>Свой контент</div>
                                    <div className='description'>
                                        Фото, видео, акции или даже прямые эфиры. Превратите экран в мощный инструмент
                                        для продвижения вашего заведения
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className='block-9'>
                            <div className='card'>
                                <div className='content'>
                                    <span>🎬</span>
                                    <div className='content-container'>
                                        <div className='title'>
                                            Познакомьтесь с сервисом заранее
                                        </div>
                                        <div className='description'>
                                            Мы предоставляем демо-режим бесплатно, чтобы вы смогли оценить все
                                            возможности
                                        </div>
                                    </div>
                                </div>
                                <Link to='/register/partners/' className='button'>
                                    Попробовать бесплатно
                                </Link>
                            </div>
                        </div>
                        <div id='block-10' className='block-10'>
                            <div className='columns'>
                                <div className='column'>
                                    <div className='title'>Вопросы и ответы</div>
                                    <div className='questions'>
                                        {questions.map((question, index) => {
                                            const classList = ['question']

                                            if (this.state.accordionTabActive === index) classList.push('active')

                                            return <div key={index} className={classList.join(' ')}
                                                        onClick={() => this.setAccordionTab(index)}>
                                                <div className='head'>
                                                    <div className='title'>{question.title}</div>
                                                    <div className='arrow'>
                                                        <BusinessArrow/>
                                                    </div>
                                                </div>
                                                <div id={`question-${index}`} className='description'>
                                                    {question.description}
                                                </div>
                                            </div>
                                        })}
                                    </div>
                                </div>
                                <div className='column'>
                                    <div className='card'>
                                        <div className='info'>
                                            <div className='title'>Контакты</div>
                                            <div className='field'>
                                                <a href='tel:+79505071316'>8 950 507 13 16</a>
                                                <div className='label'>основной телефон</div>
                                            </div>
                                            <div className='field'>
                                                <a href='mailto:hello@pubhub.su'>hello@pubhub.su</a>
                                                <div className='label'>почта</div>
                                            </div>
                                        </div>
                                        <div className='buttons'>
                                            <a className='button' href='https://t.me/pubhubsu' target='_blank'>
                                                <PartnersTelegram/>
                                                @pubhubsu
                                                <span>канал</span>
                                            </a>
                                            <a className='button' href='https://t.me/pub_hub' target='_blank'>
                                                <PartnersTelegram/>
                                                @pub_hub
                                                <span>менеджер</span>
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className='block-11'>
                            <div className='label'>показываем пиво с 2020 года</div>
                        </div>
                    </div>
                </div>
                <div className='modal-mobile-menu' style={{display: this.state.isOpenMobileModal ? 'flex' : 'none'}}>
                    <div className='header'>
                        <div className='icon-button'
                             onClick={() => this.setState({isOpenMobileModal: !this.state.isOpenMobileModal})}>
                            <PartnersOpenCloserClose/>
                        </div>
                        <Link className='logo-container' to='/'>
                            <img src={PartnersLogo} alt='logo'/>
                            <div className='text'>ПабХаб</div>
                        </Link>
                    </div>
                    <div className='content'>
                        <div className='tabs'>
                            <div className='tab' onClick={() => {
                                this.scrollToElement('block-2');
                                this.setState({isOpenMobileModal: !this.state.isOpenMobileModal})
                            }}>Кому подойдёт?
                            </div>
                            <div className='tab' onClick={() => {
                                this.scrollToElement('block-6');
                                this.setState({isOpenMobileModal: !this.state.isOpenMobileModal})
                            }}>Тарифы
                            </div>
                            <div className='tab' onClick={() => {
                                this.scrollToElement('block-10');
                                this.setState({isOpenMobileModal: !this.state.isOpenMobileModal})
                            }}>Ответы
                            </div>
                        </div>
                        <div className='buttons'>
                            <Link className='button primary' to='/register/partners/'>
                                Попробовать бесплатно
                            </Link>
                            <Link className='button secondary' to='/login/partners/'>
                                Войти
                            </Link>
                        </div>
                    </div>
                    <div className='buttons'>
                        <a className='button gray' href='tel:+79505071316' target='_blank'>
                            <div className='phone'>
                                <BusinessPhone/>
                                8 950 507 13 16
                            </div>
                            <div className='span'>Пишите, звоните</div>
                        </a>
                        <a className='button gray hidden' href='https://t.me/pubhubsu' target='_blank'>
                            <div className='phone'>
                                <PartnersTelegram/>
                                @pubhubsu
                            </div>
                            <div className='span'>telegram</div>
                        </a>
                    </div>
                </div>
                <ModalComponent isOpen={this.state.isModalOpen} customClass='business-modal-overlay'
                                onClose={() => this.setModalStatus(false)}>
                    <div className='business-modal'>
                        {
                            this.state.isSuccess ? <>
                                <div className='title'>Заявка успешно отправлена</div>
                                <div className='description'>Позвоним в течение дня</div>
                            </> : <>
                                <div className='title'>Как с вами связаться?</div>
                                <div className='description'>Позвоним в течение дня</div>
                                <div className='inputs'>
                                    <span>Ваше имя</span>
                                    <div className='input'>
                                        <input placeholder='Например, Иван' type='text' value={this.state.name}
                                               onChange={(e) => this.setState({name: e.target.value})}/>
                                    </div>
                                    <span>Телефон</span>
                                    <div className='input'>
                                        <input placeholder='Например +7 000 000 00 00' type='text'
                                               value={this.state.phone}
                                               onChange={(e) => this.setState({phone: e.target.value})}/>
                                    </div>
                                </div>
                                <div className='button' onClick={this.sendBusinessRequest}>
                                    Отправить
                                </div>
                            </>
                        }
                    </div>
                </ModalComponent>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        user: state.system.user,
        mainPage: state.system.mainPage,
        categories: state.system.categories,
    };
};

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators(
        {
            updateCategories: updateCategories,
            updateUser: updateUser,
            updateMainPage: updateMainPage,
            updateNavigationParam: updateNavigationParam,
        },
        dispatch
    );
};

export default connect(mapStateToProps, mapDispatchToProps)(PartnersPage);
